import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {OnboardingService} from "../onboarding.service";
import firebase from "firebase/app";
import "firebase/auth";
import {environment} from "src/environments/environment";
import {Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import { MixpanelService } from "src/app/shared/service/mix-panel.service";
import { MixpanelEvent } from "src/app/shared/model/mix-panel-event.enum";
import { UserDetailsService } from "src/app/core/services/user-details/user-details.service";
import { ZendeskService } from "src/app/shared/service/zendesk.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm!: FormGroup;
  submitted = false;
  errMessage: string = "";
  showErrMsg: boolean = false;
  @ViewChild("progressDialog", {static: true}) secondDialog: TemplateRef<any>;
  @ViewChild("appleDialog", {static: true}) appleDialog: TemplateRef<any>;
  @ViewChild("errDialog", {static: true}) errorDialog: TemplateRef<any>;
  @ViewChild("appleErrDialog", {static: true})
  appleErrorDialog: TemplateRef<any>;
  readMore: boolean = false;
  ssoDialog: any;

  firebaseLoginMethods = environment.firebaseLoginMethods;

  constructor(
    private formBuilder: FormBuilder,
    private onboardingService: OnboardingService,
    private router: Router,
    private dialog: MatDialog,
    private mixPanelService:MixpanelService,
    private userDetailsService: UserDetailsService,
    private zenDeskService:ZendeskService
  ) {
  }

  ngOnInit(): void {
    if (firebase.apps.length === 0) {
      firebase.initializeApp(environment.firebaseConfig);
    }
    this.loginForm = this.formBuilder.group({
      emailAddress: [
        "",
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.pattern("^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z0-9]{2,4}$")
        ])
      ],
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(30)
        ])
      ]
    });
    //Pricing and access
    const redirectCountStr = localStorage.getItem('redirectCount');
    if(redirectCountStr){
      let redirectCount = parseInt(redirectCountStr);
      redirectCount--;
      localStorage.setItem('redirectCount', redirectCount.toString());
    }
  }

  get loginFormControl() {
    return this.loginForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.loginForm.dirty && this.loginForm.valid) {
      this.openDialogWithoutRef();
      // this.trackUserLogin();
      this.onboardingService.userLoginV2(this.loginForm.value).subscribe(
        (res) => {
          this.onboardingService.userDetails = res;
          this.setZenDeskUserDetails(res.id);
          if (res) {
            console.log(this.router.url);

            if (!res.isOtpVerified) {
              this.dialog.closeAll();
              this.router.navigate(["/verification"], {
                state: {userId: res.id}
              }).catch(console.error);
            }
            else if (!res.isSetupVisited) {
              this.dialog.closeAll();
              this.router.navigate([`userProfiles/${res.id}/setup/1`]).catch(console.error);
              this.trackUserLoginSuccess(res.id)
            }
            else if (this.router.url.includes("referer=") && this.router.url.includes("&") ) {
              let url = this.router.url.replace(/%2F/g, "/");
              url=url.replace('&','?');
              const final = url.split("referer=")[1];
              window.location.href = "/" + final;
              this.trackUserLoginSuccess(res.id)
            }
            else if (this.router.url.includes("referer=")) {
              const url = this.router.url.replace(/%2F/g, "/");
              const final = url.split("referer=")[1];
              window.location.href = "/" + final;
              this.trackUserLoginSuccess(res.id)
            } else {
              this.dialog.closeAll();
              //For Pricing and Access
              const redirectCount = parseInt(localStorage.getItem('redirectCount'));
              const redirectUrl = localStorage.getItem('redirectUrl');
              if (redirectCount > 0) {
                localStorage.removeItem('redirectUrl');
                localStorage.removeItem('redirectCount');
                this.router.navigateByUrl(redirectUrl);
                this.trackUserLoginSuccess(res.id)
              } else {
                this.router.navigate(["/home"]).catch(console.error);
                this.trackUserLoginSuccess(res.id)
              }
              // window.location.href = "/";

            }
          }
        },
        () => {
          this.showErrMsg = true;
          this.dialog.closeAll();
          this.errMessage = "Please enter valid Email Address and Password.";
        }
      );
    }
  }

  googleSignIn() {
    this.openDialogWithoutRef();
    // this.trackUserLogin();
    const provider = new firebase.auth.GoogleAuthProvider();
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result);
        document.cookie =
          "X-Firebase-Refresh-Token=" +
          result.user.refreshToken +
          "; expires=" +
          CookieDate.toUTCString() +
          ";";

        firebase
          .auth()
          .currentUser.getIdToken(/* forceRefresh */ true)
          .then((idToken) => {
            console.log(idToken);
            document.cookie =
              "X-Firebase-Id-Token=" +
              idToken +
              "; expires=" +
              CookieDate.toUTCString() +
              ";";

            this.postUserRegistrationWithSSO(idToken);
          })
          .catch((error) => {
            console.log(error);
            this.ssoDialog.close();
            // hideLogInPopup(error, true);
          });
      })
      .catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  facebookSignIn() {
    this.openDialogWithoutRef();
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    const provider = new firebase.auth.FacebookAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        document.cookie =
          "X-Firebase-Refresh-Token=" +
          result.user.refreshToken +
          "; expires=" +
          CookieDate.toUTCString() +
          ";";
        firebase
          .auth()
          .currentUser.getIdToken(true)
          .then((idToken) => {
            document.cookie =
              "X-Firebase-Id-Token=" +
              idToken +
              "; expires=" +
              CookieDate.toUTCString() +
              ";";
            if (!this.userHasEmail(result.additionalUserInfo)) {
              this.errMessage = `Your Email must be linked with your Facebook Account for Logging in at Creatics`;
              this.dialog.open(this.errorDialog);
              return;
            }
            console.log(idToken);
            this.postUserRegistrationWithSSO(idToken);
          })
          .catch(error => this.handleErrorDialog(error));
      })
      .catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  handleErrorDialog(error) {
    this.ssoDialog.close();
    console.log(error);
    this.errMessage = error.message;
    if (this.errMessage) {
      this.dialog.open(this.errorDialog);
    }
    setTimeout(() => {
      this.dialog.closeAll();
    }, 3000);
  }

  appleSignIn() {
    // this.trackUserLogin();
    this.openDialogWithoutRef();
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    const provider = new firebase.auth.OAuthProvider("apple.com");
    provider.addScope("email");
    provider.addScope("name");
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        console.log(result);
        document.cookie =
          "X-Firebase-Refresh-Token=" +
          result.user.refreshToken +
          "; expires=" +
          CookieDate.toUTCString() +
          ";";
        if (this.isProxyEmailFromApple(result)) {
          this.dialog.closeAll();
          this.readMore = false;
          this.dialog.closeAll();
          this.dialog.open(this.appleErrorDialog);
          return;
        } else {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              document.cookie =
                "X-Firebase-Id-Token=" +
                idToken +
                "; expires=" +
                CookieDate.toUTCString() +
                ";";
              console.log(idToken);
              this.postUserRegistrationWithSSO(idToken);
            })
            .catch(() => {
              this.dialog.closeAll();
              this.ssoDialog.close();
            });
        }
      })
      .catch((error) => {
        this.handleDifferentCredentialsError(error);
      });
  }

  isProxyEmailFromApple(result) {
    return (
      result &&
      result.additionalUserInfo &&
      result.additionalUserInfo.profile?.email?.includes(
        "privaterelay.appleid.com"
      )
    );
  }

  navigateToSignUp() {
    this.router.navigate(["/signup"]).catch(console.error);
  }

  navigateToForgotPassword() {
    this.router.navigate(["/reset-password"]).catch(console.error);
  }

  postUserRegistrationWithSSO(token) {
    const CookieDate = new Date();
    CookieDate.setFullYear(CookieDate.getFullYear() + 10);
    this.onboardingService.ssoSignIn(token).subscribe(
      (res) => {
        console.log(res);
        this.setZenDeskUserDetails(res.id);
        document.cookie =
          "X-Firebase-Session=" +
          res.sessionCookie +
          "; expires=" +
          CookieDate.toUTCString() +
          ";";
        this.ssoDialog.close();
        if (res) {
          if (!res.isSetupVisited) {
            this.ssoDialog.close();
            this.hideAppleInstructions();
            this.trackUserLoginSuccess(res.id)
            this.router.navigate([`userProfiles/${res.id}/setup/1`]).catch(console.error);
          } else {
            this.ssoDialog.close();
            this.hideAppleInstructions();
            this.trackUserLoginSuccess(res.id)
            window.location.href = "/";
          }
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }

  openDialogWithoutRef() {
    this.ssoDialog = this.dialog.open(this.secondDialog, {
      disableClose: true
    });
    console.log(this.ssoDialog);
  }

  showAppleInstructions() {
    this.dialog.open(this.appleDialog, {disableClose: true});
  }

  hideAppleInstructions() {
    if (this.appleDialog) {
      this.dialog.openDialogs?.forEach(dialog => dialog?.close());
    }
  }

  ngOnDestroy(): void {
    this.dialog.closeAll();
  }

  userHasEmail(additionalUserInfo) {
    // noinspection RegExpRedundantEscape
    return (
      additionalUserInfo &&
      additionalUserInfo.profile &&
      additionalUserInfo.profile.email &&
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        additionalUserInfo.profile.email
      )
    );
  }

  onClickReadMore() {
    this.readMore = !this.readMore;
  }

  handleDifferentCredentialsError(error) {
    if (error.code === "auth/account-exists-with-different-credential") {
      const email = error.email;
      let primaryPlatform = '';
      firebase
        .auth()
        .fetchSignInMethodsForEmail(email)
        .then((methods) => {
          if (methods[0] === "google.com") {
            primaryPlatform = 'Google';
            // this.googleSignIn();
          } else if (methods[0] === "facebook.com") {
            primaryPlatform = 'Facebook';
            // this.facebookSignIn();
          } else {
            primaryPlatform = 'Apple';
            // this.appleSignIn();
          }
          this.handleErrorDialog({
            message: `An account already exists with ${
                email
              } but with different social sign-in platform. Please use <strong>Continue with ${
                primaryPlatform
              }</strong> to sign in.`
          });
        })
        .catch((error) => this.handleErrorDialog(error));
    } else {
      this.handleErrorDialog(error);
    }
  }

  // trackUserLogin(){
  //   this.mixPanelService.trackEvent(
  //     {
  //       event:MixpanelEvent.LOGIN_STARTED,
  //       properties:{}
  //     }
  //   )
  // }
  trackUserLoginSuccess(userId:string){
    this.mixPanelService.identifyUser(userId);
    this.mixPanelService.trackEvent(
      {
        event:MixpanelEvent.LOGIN_SUCCESS,
        properties:{}
      }
    )
  }
  setZenDeskUserDetails(userId:string) {
    this.userDetailsService.getUserDetails(userId).subscribe({
      next:(res: any) => {
      let name =  res.firstName + " "+ res.lastName;
      let email = res.emailAddress;
      this.zenDeskService.setUserIdentity(userId,name,email);
    },
    error:(err)=>{
      console.log(err)}
    }
  )
  }
}
